import React from "react"
import PersonalInfo from "../../steps/PersonalInfo/PersonalInfo"

export default function PersonalInfoMainMenu({ currentLoggedUserId, wizardCompleted }) {
    return (
        <div className="cv-main-menu-overview p-2">
            <PersonalInfo currentLoggedUserId={currentLoggedUserId} wizardCompleted={wizardCompleted}/>
        </div>
    )
}